import { render, staticRenderFns } from "./SMSListContainer.vue?vue&type=template&id=5a3a4ddb&scoped=true"
import script from "./SMSListContainer.vue?vue&type=script&lang=js"
export * from "./SMSListContainer.vue?vue&type=script&lang=js"
import style0 from "./SMSListContainer.vue?vue&type=style&index=0&id=5a3a4ddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a4ddb",
  null
  
)

export default component.exports